import { EntityTypes } from 'constants/entities';
import { getRequest } from 'core/services/admin';
import { useAppDispatch, useAppSelector } from 'core/store/hooks';
import { shouldRequest } from 'core/services/requestDedupe';
import { useCallback, useEffect } from 'react';

/**
 * @param skip pass true when the store already holds the entity and does not need
 *   re-fetching. Re-evaluated when it changes, so a caller can start out skipping and
 *   fetch later (or vice versa).
 */
export function useGet(type: EntityTypes, id?: number, skip?: boolean) {
  const state = useAppSelector(state => state[type]);
  const dispatch = useAppDispatch();

  const fetchData = useCallback(() => {
    const entityId = id ?? state?.id;

    if (!shouldRequest(`get:${type}:${entityId ?? 'all'}`)) return;

    dispatch(
      getRequest({
        type,
        ...(entityId ? { entityId } : {}),
      }),
    );
  }, [dispatch, id, state?.id, type]);

  useEffect(() => {
    if (skip) return;

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, skip]);
}
